module.exports = __webpack_public_path__ + "static/productivity-tab-cover-8c73ff14fd451bf5f7140d44218dc8d3.png";